import { DateTime } from 'luxon'

import type { ReeferSpeedGraphParams } from './types'

const WALL_CLOCK = "yyyy-MM-dd'T'HH:mm:ss"

const FIXED_DAY_OPTIONS = new Set(['today', 'yesterday'])

const hasOffset = (value: string): boolean => /([zZ]|[+-]\d\d:?\d\d)$/.test(value)

function windowStart(date: string, fromISO: string | undefined, periodHours: number, zone: string): DateTime {
  const now = DateTime.now().setZone(zone)

  if (date === 'custom' && fromISO) {
    if (!hasOffset(fromISO)) {
      const picked = DateTime.fromISO(fromISO, { zone })
      return picked.isValid ? picked : now.startOf('day')
    }
    const absolute = DateTime.fromISO(fromISO)
    const literal = (absolute.isValid ? absolute : now).toFormat(WALL_CLOCK)
    return DateTime.fromISO(literal, { zone })
  }

  if (date === 'thisWeek') return now.startOf('week')
  if (date === 'lastWeek') return now.minus({ weeks: 1 }).startOf('week')
  if (date === 'thisMonth') return now.startOf('month')
  if (date === 'previous1Month') return now.minus({ months: 1 }).startOf('month')
  if (date === 'yesterday') return now.minus({ days: 1 }).startOf('day')
  if (date === 'last24Hours') return now.plus({ hours: 1 }).startOf('hour').minus({ hours: periodHours })

  return now.startOf('day')
}

export interface ResolvedWindow {
  from: DateTime
  to: DateTime
  hours: number
}

export function resolveWindow(params: ReeferSpeedGraphParams, zone: string): ResolvedWindow {
  const date = params.date || 'today'
  const requested = parseInt(params.periodHours || '24', 10) || 24
  const hours = FIXED_DAY_OPTIONS.has(date) ? 24 : requested
  const from = windowStart(date, params.from, hours, zone)
  return { from, to: from.plus({ hours }), hours }
}

export const toWallClock = (dt: DateTime): string => dt.toFormat(WALL_CLOCK)
